import { useState, useEffect } from 'react';
import { logError } from '../utils/logger';

/**
 * Hook to load static metadata from API endpoints.
 * Categories + assignees loaders for tickets. Returns sane defaults until loaded.
 */
export function useTicketMeta(getCategories, getAssignees) {
  const [categories, setCategories] = useState([]);
  const [assignees, setAssignees] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const cats = await getCategories();
        if (mounted) setCategories(cats.data);
      } catch (e) { logError('useTicketMeta.categories', e); }
      try {
        const ass = await getAssignees();
        if (mounted) setAssignees(ass.data);
      } catch (e) {
        // 403 esperado para não-admins — silencioso em produção
        logError('useTicketMeta.assignees', e);
      }
    };
    load();
    return () => { mounted = false; };
  }, [getCategories, getAssignees]);

  return { categories, assignees };
}
